/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { QA_DEV } = process.env
const { API } = process.env

const apiService = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? QA_DEV : API,
  withCredentials: true,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiService.interceptors.response.use(
  (response) => {
    const loginPage = window.location.pathname.indexOf('/') !== -1
    // if (response.status === 403 && loginPage) {
    //   sessionStorage.setItem('userStatus', '')
    //   window.location.href = '/'
    // }
    return response
  },
  (error) => {
    const loginPage = window.location.pathname.indexOf('/') !== -1
    if (error.response.status === 403 && loginPage) {
      sessionStorage.setItem('userStatus', '')
      window.location.href = '/'
    }
    // if (
    //   error.response.status === 500 &&
    //   process.env.NODE_ENV !== 'development'
    // ) {
    //   sessionStorage.setItem('userStatus', '')
    //   window.location.href = '/'
    // }
    return Promise.reject(error)
  },
)

export { apiService }
